"use client";

import AIChatFeedbackButtons from "@/components/AIChatFeedbackButtons";
import AIChatCopyButton from "@/components/AIChatCopyButton";
import {
  AI_CHAT_FEEDBACK_CAPTURE_STATUS,
  buildAIChatFeedbackMessageId,
} from "@/lib/ai-chat-feedback-utils";

// Must match app/api/home/sabine/route.js, which logs every Q&A under
// buildAIChatFeedbackMessageId(FEEDBACK_SOURCE, <user message id>) — a vote
// here then updates that row instead of creating a second one.
const FEEDBACK_SOURCE = "HOME_SABINE";
const FEEDBACK_CONTEXT_TYPE = "HOME_CHAT";

const getMessageId = (message, index) =>
  message?.id || `${message?.role || "message"}-${index}`;

function findPreviousUserMessage(messages, index) {
  for (let i = index - 1; i >= 0; i -= 1) {
    if (messages[i]?.role === "user") return { message: messages[i], index: i };
  }
  return null;
}

/**
 * Action row under a Sabine reply on the home page: thumbs up/down plus copy,
 * the same controls (and look) as the Sabine chat panel. Hidden while the reply
 * is still streaming (`deferred`).
 */
export default function SabineMessageActions({
  messages,
  index,
  deferred = false,
}) {
  const message = messages?.[index];
  const answer = typeof message?.content === "string" ? message.content : "";
  if (deferred || !answer.trim()) return null;

  const previous = findPreviousUserMessage(messages, index);
  const question =
    typeof previous?.message?.content === "string"
      ? previous.message.content
      : "";
  const previousUserMessageId = previous
    ? getMessageId(previous.message, previous.index)
    : null;

  return (
    <div className="mt-3 flex items-center">
      {question.trim() ? (
        <AIChatFeedbackButtons
          question={question}
          answer={answer}
          source={FEEDBACK_SOURCE}
          contextType={FEEDBACK_CONTEXT_TYPE}
          messageId={buildAIChatFeedbackMessageId(
            FEEDBACK_SOURCE,
            previousUserMessageId
          )}
          trailingAction={<AIChatCopyButton text={answer} />}
          metadata={{
            captureStatus: AI_CHAT_FEEDBACK_CAPTURE_STATUS.COMPLETED,
            assistantMessageId: getMessageId(message, index),
            userMessageId: previousUserMessageId,
          }}
        />
      ) : (
        <AIChatCopyButton text={answer} />
      )}
    </div>
  );
}
